import { jsx as m } from "react/jsx-runtime";
import { ModalHeader as a } from "./index.es767.js";
import { ModalFooter as d } from "./index.es768.js";
import { BaseModalContent as l } from "./index.es769.js";
import { BaseModal as p } from "./index.es770.js";
const M = "modal-template", o = ({
  testId: t = M,
  hasBackdrop: r = !0,
  ...e
}) => /* @__PURE__ */ m(p, { ...e, testId: t, hasBackdrop: r });
o.Header = a;
o.Footer = d;
o.Content = l;
export {
  M as MODAL_TEMPLATE_DEFAULT_TESTID,
  o as Modal
};
//# sourceMappingURL=index.es88.js.map
